<div
    [id]="id()"
    [attr.data-testId]="currentTestId()"
    [attr.data-styleTarget]="id()"
    [attr.data-uiTarget]="'viz'"
    class="rounded-md p-4 dat-border-card grid grid-cols-1 gap-y-2 md:grid-cols-6 md:gap-x-4 md:gap-y-4 font-body-1 auto-rows-[60px] md:auto-rows-[60px]"
>
    <div
        [attr.data-uiTarget]="'container-viz-header'"
        class="md:col-span-6 rounded-md p-4"
    >
        <h3 class="font-card-title m-0">
            Total Projects: {{ numOfProjects | number }}
        </h3>
    </div>
    <div
        [attr.data-uiTarget]="'container-viz'"
        class="dat-border-card md:col-span-3 row-span-3 rounded-md p-4"
    >
        <h3 class="font-card-title m-0">Dependencies</h3>
        <div class="w-full h-full" #deps></div>
    </div>
    <div
        [attr.data-uiTarget]="'container-viz'"
        class="dat-border-card md:col-span-3 row-span-3 rounded-md p-4"
    >
        <h3 class="font-card-title m-0">Environments</h3>
        <div class="w-full h-full" #env></div>
    </div>
    <div
        [attr.data-uiTarget]="'container-viz'"
        class="dat-border-card md:col-span-2 row-span-3 rounded-md p-4"
    >
        <h3 class="font-card-title m-0">Team</h3>
        <div class="w-full h-full" #team></div>
    </div>
    <div
        [attr.data-uiTarget]="'container-viz'"
        class="dat-border-card md:col-span-2 row-span-3 rounded-md p-4"
    >
        <h3 class="font-card-title m-0">Component Types</h3>
        <div class="w-full h-full" #domains></div>
    </div>
    <div
        [attr.data-uiTarget]="'container-viz'"
        class="dat-border-card md:col-span-2 row-span-3 rounded-md p-4"
    >
        <h3 class="font-card-title m-0">Library Types</h3>
        <div class="w-full h-full" #libraryTypes></div>
    </div>
</div>
